<app-icon [svgIcon]="icon()" [matTooltip]="tooltip()" [disabled]="isDisabled()" [isClickable]="isClickable()"></app-icon>
